import { MainPageTemplate } from 'src/layout/SidebarLayout/MainPageLayout/MainPageTemplate';

import { CustomersTable } from './CustomersTable';

export const CustomersPage = () => {
  return (
    <MainPageTemplate title="Customers">
      <CustomersTable />
    </MainPageTemplate>
  );
};
